<!-- Global Actions -->
<ng-container *ngIf="globalActions$ | async as globalActions">
  <div *ngIf="globalActions.length > 0" class="global-actions-wrapper">
    <ng-container *ngFor="let action of globalActions">
      <p-button
        type="button"
        [jmlVar]="{ inProgress: false }"
        #actionButton="jmlVar"
        [icon]="action.icon"
        class="action-button"
        [disabled]="actionButton.inProgress"
        [label]="action.tooltip"
        (click)="performAction(action.hrid, actionButton)"
      >
      </p-button>
    </ng-container>
  </div>
</ng-container>

<div class="script-header">
  <span class="text-xl font-medium">Skript IDE</span>

  <div
    class="flex justify-content-between align-items-center"
    jmlFavoriteButton
    [favoriteId]="'script-ide'"
    [favoriteName]="'Skript IDE'"
    [favoriteIcon]="'fa fa-terminal'"
    [favoriteRoute]="'/configuration/script-ide'"
  ></div>
</div>

<p-card>
  <div class="ide-container">
    <!-- Code Editor Section -->
    <div class="code-section">
      <div class="code-area">
        <ace [config]="aceconfig" [(value)]="code" [mode]="'python'" (valueChange)="onChange($event)"> </ace>
      </div>
    </div>

    <!-- Results Section -->
    <div class="results-section">
      <ng-container *ngIf="!loading; else spinner">
        <!-- Result Input -->
        <div class="result-container">
          <label>Ergebnis</label>
          <input type="text" id="result" class="p-inputtext w-full monospace" pInputText [value]="result" />
        </div>

        <!-- Output Container - takes remaining space -->
        <div class="output-container">
          <label>Ausführungsdetails</label>
          <textarea pInputTextarea id="output" class="output-textarea" [value]="output"> </textarea>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="action-buttons">
    <button pButton (click)="execute()" pTooltip="Ausführen" icon="pi pi-play"></button>
    <button pButton (click)="delete()" pTooltip="Löschen" icon="pi pi-trash"></button>
  </div>
</p-card>
<ng-template #spinner>
  <div class="flex justify-content-center align-items-center h-full">
    <div>
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>
</ng-template>
